import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
// import ElementPlus from 'element-plus'
 //import 'element-plus/dist/index.css'
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  MessageBox,
  Calendar,
  Tag,
  Tree,
  Select,
  Option,
  Cascader,
  Alert,
  Tabs,
  TabPane,
  Step,
  Steps,
  CheckboxGroup,
  Checkbox,
  Upload,
  Timeline,
  TimelineItem,
  DatePicker,
  Divider,
  DescriptionsItem,
  Descriptions,
  Statistic,
  Carousel,
  CarouselItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Icon,
  InfiniteScroll,
  Loading,
  Progress,
  Drawer,
} from 'element-ui'
Vue.use(Drawer)
Vue.use(Progress)
Vue.use(Loading)
Vue.use(InfiniteScroll)
Vue.use(DropdownMenu)
Vue.use(Dropdown)
Vue.use(Icon)
Vue.use(DropdownItem)
Vue.use(CarouselItem)
Vue.use(Carousel)
Vue.use(Statistic)
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(Tooltip);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Alert);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Step);
Vue.use(Steps);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Upload);
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(DatePicker)
Vue.use(Divider)
Vue.use(Calendar)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
